module.exports = __webpack_public_path__ + "img/广防己.a1711f86.jpg";